import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { Chart } from "react-google-charts";
import {
	BOX_SHADOWS,
	DATA_TYPES,
	EMPTY_MESSAGES,
	EMPTY_MESSAGE_IMAGES,
	FONTS,
	PRIMARY_COLOR,
	SECONDARY_COLOR,
} from "../../constants";
import { stateType } from "../../state";
import { BoxHeader } from "../Common/BoxHeader";
import { EmptyMessage } from "../Common/EmptyMessage";
import { makeHistData } from "../Common/makeHistData";
import { FilterHistogram } from "./FilterHistogram";
import { applyFiltersToData } from "./filters";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		container: {
			boxShadow: BOX_SHADOWS,
			backgroundColor: "white",
			width: "100%",
			height: "600px",
			display: "flex",
			flexDirection: "column",
			borderRadius: "10px",
			overflow: "hidden",
		},
		topTab: { display: "flex", flexDirection: "row" },
		chartContainer: {
			display: "flex",
			flexDirection: "column",
		},
		checkBox: {
			display: "flex",
			flexDirection: "row",
			justifyContent: "center",
			fontSize: 15,
			color: "grey",
			fontFamily: FONTS,
		},
		checkText: { whiteSpace: "nowrap", marginTop: "10px" },
	})
);

export function NumericChart({ state }: stateType) {
	let col = state.saveState.dataset.getColumn(
		state.saveState.cleanData.cleanHistSelected
	);
	if (col === undefined) {
		return <div></div>;
	}
	let cleanHistData = state.saveState.cleanData.cleanHistData;

	if (cleanHistData === undefined) {
		// Get filtered data
		let { data } = applyFiltersToData(
			state.saveState.dataset.data,
			col.columnName,
			state.saveState.cleanData.cleanDataFilters,
			new Set(),
			new Set()
		);
		cleanHistData = makeHistData(
			data,
			col.columnType,
			state.saveState.cleanData.cleanRowsSelected,
			col.colStats.median
		);
		state.saveState.cleanData.cleanHistData = cleanHistData;
		state.setSaveState(state.saveState);
	}

	if (cleanHistData.length === 0) {
		return (
			<EmptyMessage
				image={EMPTY_MESSAGE_IMAGES.noData}
				message1={EMPTY_MESSAGES.empty1}
				message2={EMPTY_MESSAGES.filteredOut}
				button={false}
			></EmptyMessage>
		);
	}
	return (
		<div
			style={{
				marginTop: "30px",
				marginLeft: "-50px",
				marginRight: "50px",
			}}
		>
			<FilterHistogram
				state={state}
				histData={cleanHistData}
				title={""}
				isCat={false}
			></FilterHistogram>
			;
		</div>
	);
}

export function CategoricalChart({ state }: stateType) {
	let col = state.saveState.dataset.getColumn(
		state.saveState.cleanData.cleanHistSelected
	);
	if (col === undefined) {
		return <div></div>;
	}

	let cleanHistData = state.saveState.cleanData.cleanHistData;
	if (cleanHistData === undefined) {
		// Get filtered data
		let { data } = applyFiltersToData(
			state.saveState.dataset.data,
			col.columnName,
			state.saveState.cleanData.cleanDataFilters,
			new Set(),
			new Set()
		);

		cleanHistData = makeHistData(
			data,
			col.columnType,
			state.saveState.cleanData.cleanRowsSelected,
			col.colStats.median
		);
		state.saveState.cleanData.cleanHistData = cleanHistData;
		state.setSaveState(state.saveState);
	}
	if (cleanHistData.length === 1) {
		return (
			<EmptyMessage
				image={EMPTY_MESSAGE_IMAGES.noData}
				message1={EMPTY_MESSAGES.empty1}
				message2={EMPTY_MESSAGES.filteredOut}
				button={false}
			></EmptyMessage>
		);
	}
	return (
		<Chart
			width={"100%"}
			height={"100%"}
			chartType="BarChart"
			loader={<div>Loading Chart</div>}
			data={[...cleanHistData]}
			options={{
				series: [{ color: SECONDARY_COLOR, dataOpacity: 0.8 }],
				chartArea: { width: "80%", height: "80%" },
				legend: { position: "none" },
				hAxis: {
					title: "Counts",
					minValue: 0,
					textStyle: { fontName: FONTS },
				},
				vAxis: { textStyle: { fontName: FONTS } },
			}}
			// For tests
			rootProps={{ "data-testid": "1" }}
		/>
	);
}

export function FilterHistogramBox({ state }: stateType) {
	let classes = useStyles();

	function SelectedChart() {
		const selected = state.saveState.cleanData.cleanHistSelected;
		let col = state.saveState.dataset.getColumn(selected);
		if (col === undefined) {
			return <div></div>;
		}
		if (col.columnType === DATA_TYPES.number) {
			return <NumericChart state={state}></NumericChart>;
		} else {
			return (
				<div style={{ height: "500px" }}>
					{" "}
					<CategoricalChart state={state}></CategoricalChart>
				</div>
			);
		}
	}

	return (
		<div className={classes.container}>
			<BoxHeader
				title={"Filtered Data Preview"}
				toolTip={
					"What your dataset looks like after applying the filters and dropped rows."
				}
			></BoxHeader>
			{SelectedChart()}
		</div>
	);
}
